import { Button, H2 } from "@sellar-io/components";
import { useEffect } from "react";
import { DialogContent } from "../../../../../../../../components/modal/Dialog";
import { useFullPageDialogContext } from "../../../../../../../../components/modal/useFullPageDialogContext";
import { useLegalEntityCompanyCreditInfo } from "../../../../../../../../hooks/api/v2/legalEntity/useLegalEntityCompanyCreditInfo";
import { useSellarCurrentBusiness } from "../../../../../../../../hooks/useSellarCurrentBusiness.shared";
import { SellarCreditTwoDialogPageEnum } from "../types/SellarCreditTwoDialogPageEnum";
import { useTwoPreverificationAccount } from "../../../../../../../../hooks/api/v2/two/useTwoPreverificationAccount";

export const SellarCreditCheckWelcome = () => {
  const { setPage } = useFullPageDialogContext();

  const { business } = useSellarCurrentBusiness();

  const { data: companyCreditInfoData, isLoading: companyCreditInfoLoading } =
    useLegalEntityCompanyCreditInfo(
      {
        RetailerId: business?.Retailer?.id ?? 0,
      },
      {
        enabled: Boolean(business?.Retailer?.id),
      },
    );

  const {
    data: twoPreverificatonAccountData,
    isLoading: twoPreverificatonAccountLoading,
  } = useTwoPreverificationAccount();

  const actionButtonCopy = companyCreditInfoData?.creditLimitQuote
    ? "Setup your account"
    : "Check your credit limit";

  // if declined credit - show ineligible step
  useEffect(() => {
    if (
      ["declined", "noCreditOffered"].includes(
        companyCreditInfoData?.status ?? "",
      )
    ) {
      setPage(SellarCreditTwoDialogPageEnum.NOT_ELIGIBLE);
    }
  }, [companyCreditInfoData?.status, setPage]);

  // if two preverification already exists, redirect to login check page

  useEffect(() => {
    if (twoPreverificatonAccountData?.id) {
      setPage(SellarCreditTwoDialogPageEnum.LOGIN_CHECK);
    }
  }, [setPage, twoPreverificatonAccountData]);

  const isLoading = companyCreditInfoLoading || twoPreverificatonAccountLoading;

  return (
    <>
      <DialogContent className="flex h-full items-center justify-center">
        <div className="flex flex-col gap-2 text-center">
          <div className="flex flex-col items-center gap-6">
            <img
              src="https://sellar.imgix.net/sellar-image-assets/sellar-credit/sc-invoice.svg"
              className="w-[190px]"
            />
          </div>

          <H2>One monthly payment, up to 60-day terms, no fees</H2>
          <p>
            Get end of month + 30 days credit with hundreds of suppliers, all in
            one monthly payment with no fees attached.
            {!companyCreditInfoData?.creditLimitQuote && (
              <>
                {" "}
                You can do a quick check now to see how much credit you're
                eligible for, it won't affect your credit score.
              </>
            )}
          </p>
          <div className="mt-4 flex w-full flex-col gap-2">
            <Button
              disabled={isLoading}
              className="w-full"
              onClick={() => {
                // if quote already exists - skip to the two application intro
                if (companyCreditInfoData?.creditLimitQuote) {
                  return setPage(
                    SellarCreditTwoDialogPageEnum.TWO_ACCOUNT_VERIFICATION_INTRO,
                  );
                }

                setPage(SellarCreditTwoDialogPageEnum.SEARCH_COMPANY);
              }}
            >
              {actionButtonCopy}
            </Button>
            <Button
              color="secondary"
              className="w-full"
              onClick={(e) => {
                e.preventDefault();
                window.open(
                  `https://sellar.io/sellar-credit-for-buyers?utm_source=sellar&utm_medium=app&utm_content=buyer-learn-more`,
                  "_blank",
                );
              }}
            >
              Find out more
            </Button>
          </div>
        </div>
      </DialogContent>
    </>
  );
};
